import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { logout } from '../../features/auth/authSlice';
import { Dropdown } from '../ui';
import type { DropdownItem } from '../ui';
import { BellIcon, GridIcon } from '../../assets/icons';
import adminAvatar from '../../assets/avatars/admin-user.png';

const MENU_ITEMS: DropdownItem[] = [
  { key: 'profile', label: 'Profile' },
  { key: 'divider', divider: true },
  { key: 'logout', label: 'Sign out', danger: true },
];

interface TopNavBarProps {
  /** Opens the sidebar drawer on mobile. */
  onMenuClick?: () => void;
}

export default function TopNavBar({ onMenuClick }: TopNavBarProps) {
  const dispatch = useAppDispatch();
  const user = useAppSelector((s) => s.auth.user);

  const onSelect = (key: string) => {
    if (key === 'logout') dispatch(logout());
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-40 flex h-16 items-center justify-between border-b border-line bg-white px-4 shadow-topbar sm:px-6">
      {/* Left: hamburger (mobile) + brand */}
      <div className="flex items-center gap-2">
        <button
          type="button"
          aria-label="Open navigation"
          onClick={onMenuClick}
          className="flex size-9 flex-col items-center justify-center gap-[5px] rounded-lg text-ink-700 transition-colors hover:bg-brand-shade lg:hidden"
        >
          <span className="h-0.5 w-5 rounded-full bg-current" />
          <span className="h-0.5 w-5 rounded-full bg-current" />
          <span className="h-0.5 w-5 rounded-full bg-current" />
        </button>
        <Link
          to="/admin/organizations"
          aria-label="Go to Organizations"
          className="flex items-center text-[20px] font-bold leading-7 text-brand-dark no-underline"
        >
          CHUNAAV
        </Link>
      </div>

      {/* Right cluster */}
      <div className="flex items-center gap-2 sm:gap-4">
        <button
          type="button"
          aria-label="Notifications"
          className="flex items-center justify-center px-2 pb-3.5 pt-2 text-ink-700 transition-colors hover:text-brand"
        >
          <BellIcon className="h-5 w-4" />
        </button>
        <button
          type="button"
          aria-label="Apps"
          className="flex items-center justify-center px-2 pb-3.5 pt-2 text-ink-700 transition-colors hover:text-brand"
        >
          <GridIcon className="h-4 w-4" />
        </button>

        <div className="px-2">
          <span className="block h-8 w-px bg-line" />
        </div>

        <Dropdown items={MENU_ITEMS} onSelect={onSelect}>
          <span className="flex items-center gap-3">
            <span className="hidden flex-col items-end sm:flex">
              <span className="text-sm font-bold leading-[17.5px] text-ink-900">
                {user?.name ?? 'Admin User'}
              </span>
              <span className="text-xs font-medium leading-4 tracking-[0.6px] text-ink-700">
                {user?.role ?? 'System Administrator'}
              </span>
            </span>
            <span className="flex size-10 items-center justify-center overflow-hidden rounded-full border border-line bg-brand-avatar">
              <img
                src={adminAvatar}
                alt={user?.name ?? 'Admin User'}
                className="size-full object-cover"
              />
            </span>
          </span>
        </Dropdown>
      </div>
    </header>
  );
}
